<div class="layout-wrapper">
  <app-topbar></app-topbar>
<main class="layout-container">
  <div class="layout-content-wrapper">
    <router-outlet></router-outlet>
    <div class="layout-content grid mr-0 ml-0 flex flex-column align-content-center justify-content-center" style="min-height: calc(100vh - 37px);">
      <div class="md:col-10 col-12 md:mx-auto md:px-0 px-3">
        <div class="grid">
          <div class="col-12 md:col-12 mb-4 surface-card p-4 shadow-2 border-round">
            <div class="flex align-content-center flex-wrap">
              <h2 class="text-center mt-3 fadeinleft animation-duration-1000" style="color: rgb(9, 64, 103);">
                Como posso te ajudar hoje?
                <span class="fadein animation-duration-1000 animation-iteration-infinite">_</span>
              </h2>

             <div class="flex align-items-center w-12 gap-2">
                <!-- Dropdown
                <p-dropdown
                  [options]="types"
                  [(ngModel)]="selectedType"
                  class="w-16rem tema">
                </p-dropdown>-->
                <div class="input-container">
                  <input
                    type="text"
                    placeholder="Encontre o prompt ideal..."
                    class="p-inputtext-lg w-full input-with-button"
                    pInputText
                    (keyup.enter)="buscar()"
                    [(ngModel)]="valorBusca"
                  />
                  <button
                    title="Buscar prompt"
                    class="btn-search"
                    (click)="buscar()"
                  >
                    <i class="pi pi-search"></i>
                  </button>
                </div>
              </div>
            </div>
              <!-- Badges com categorias selecionadas -->
              <div class="flex flex-wrap gap-2 mt-4">
                <p-chip
                  *ngFor="let cat of selectedCategories"
                  [label]="cat"
                  removable="true"
                  class="chip-cat"
                  (onRemove)="removeCategory(cat)">
                </p-chip>
              </div>
          </div>

          <!--
          <div class="relative inline-block w-full mb-3" #painelContainer>
            <button pButton type="button" label="Categorias" icon="pi pi-chevron-down" (click)="togglePainel()" class="bt-tema"></button>

            <div
              *ngIf="mostrarPainel"
              @slideDown
              class="z-2 w-12 mt-2 bg-white shadow-3 border-round p-3"
              style="top: 100%; left: 0;">

              <h2> Categorias</h2>
                <div class="flex flex-column gap-3 w-full">


                  <span class="p-input-icon-left">
                    <input type="text" pInputText placeholder="Buscar categoria" [(ngModel)]="searchTerm" class="w-full" />
                  </span>


                  <div class="flex flex-column gap-2 max-h-20rem overflow-y-auto border-1 surface-border border-round p-3">
                    <div *ngFor="let category of filteredCategories()" class="flex align-items-center gap-2">
                      <p-checkbox
                        [inputId]="category"
                        [value]="category"
                        [(ngModel)]="selectedCategories"
                        binary="false"
                        (onChange)="onCategoryChange()"
                        (click)="$event.stopPropagation()">>
                      </p-checkbox>
                      <label [for]="category">{{ category }}</label>
                    </div>


                    <div class="flex justify-content-end gap-2 mt-3">
                      <button pButton type="button" (click)="applySelection()" class="bt-tema">Aplicar</button>
                      <button pButton type="button" severity="secondary" (click)="clearSelection()">Limpar</button>
                     </div>
                  </div>
                </div>

            </div>
          </div>-->

          <!--  <div class="col-12 md:col-12 hidden md:block mt-4">
              <swiper-container
                style="
                  --swiper-navigation-color: #dcd8d8;
                  --swiper-pagination-color: #fff;
                  --swiper-pagination-bullet-inactive-color: #ffffff;"
                class="mySwiper"
                navigation="true"
                pagination="true"
                pagination-clickable="true"
                slides-per-view="1"
                autoplay-delay="3000"
                autoplay-disable-on-interaction="false"
                speed="600"
                parallax="true">
                <div
                  slot="container-start"
                  class="parallax-bg"
                  style="
                    background-image: url(../../../assets/imagem/bg-perfil.PNG);"
                  data-swiper-parallax="-23%">
                </div>
                <swiper-slide *ngFor="let review of reviews">
                  <a
                    [routerLink]="['tela-prompt', review.id]"
                    class="text-gray-800 no-underline">
                    <div class="flex align-items-center gap-5">
                      <p-avatar
                        [image]="review.avatar"
                        styleClass="mr-2"
                        size="xlarge"
                        shape="circle">
                      </p-avatar>
                      <div>
                        <div>
                          <div class="font-bold mb-2 text-2xl">{{ review.name }}</div>
                          <div class="font-italic font-light">
                            {{ review.quote ? '"' + review.quote + '"' : "Frase não informada" }}
                          </div>
                        </div>
                        <div class="flex align-items-center justify-content-between mt-2">
                          <div class="font-bold text-3xl">
                            <ng-container *ngFor="let star of [].constructor(review.rating); let i = index">
                              <span class="text-yellow-500">★</span>
                            </ng-container>
                          </div>
                        </div>
                        <div class="mb-2 font-medium">{{ review.title }}</div>
                      </div>
                    </div>
                  </a>
                </swiper-slide>
              </swiper-container>
            </div>-->
         <!-- carrossel.component.html -->
         <swiper-container
          class="mySwiper"
          pagination="true"
          pagination-clickable="true"
          slides-per-view="3"
          autoplay-delay="3000"
          autoplay-disable-on-interaction="false"
          speed="600"
          [breakpoints]="{
            '0': { slidesPerView: 1 },
            '1024': { slidesPerView: 3 }
          }"
          >
         <swiper-slide *ngFor="let review of reviews">
            <a
              (click)="telaPrompt(review.id)"
              class="text-gray-800 no-underline cursor-pointer"
            >
              <div class="card-slide" style="
                background:linear-gradient(to left, rgba(38, 79, 149, 0.2), rgba(31, 160, 152, 0.2));">
                <div class="icon-wrapper">
                  <p-avatar
                    [image]="review.avatar"
                    styleClass="mr-2"
                    size="large"
                    shape="circle">
                  </p-avatar>
                </div>
                <p>{{ review.name }}</p>
                <p>
                  {{ review.quote ? '"' + review.quote + '"' : "" }}
                </p>
                <div class="flex align-items-center justify-content-center mt-2">
                  <div class="font-bold text-3xl">
                    <ng-container *ngFor="let star of [].constructor(review.rating); let i = index">
                      <span class="text-yellow-500">★</span>
                    </ng-container>
                  </div>
                </div>
                <div class="mb-2 font-medium">{{ review.title }}</div>
              </div>
            </a>
         </swiper-slide>
       </swiper-container>
           <!-- <div class="col-12 md:col-10 block md:hidden">
              <div class="font-medium text-2xl text-900 mb-2">Top 10</div>
              <a *ngFor="let review of reviews"
                  [routerLink]="['tela-prompt', review.id]"
                  class="text-gray-800 no-underline block">
                  <div class="flex align-items-center md:gap-8 gap-1 bg-gray-100 p-2 border-round mb-2">
                    <p-avatar [image]="review.avatar" shape="circle" styleClass="mr-2"></p-avatar>
                    <span class="font-medium text-xs flex-grow-1">{{ review.name }}</span>
                    <div class="flex align-items-center gap-1">
                      <ng-container *ngFor="let star of [].constructor(review.rating); let i = index">
                        <span class="text-yellow-500">★</span>
                      </ng-container>
                    </div>
                  </div>
                </a>
            </div>-->
         </div>
      </div>
    </div>
  </div>
</main>
</div>
